/* 
    TOKEN_ADDRESS  ERC-20
    CONTRACT_ADDRESS  合约地址
*/
// TOKEN_ADDRESS test
// const USDT_ADDRESS = `0x88064637509289347B4A462d901C16fdb3ABdFcF`; //测试代币

const BNB_ADDRESS = `0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c`;
const GMC_ADDRESS = `0x3986E442351649EC45949B02716e75e9fA1DF951`;
const USDT_ADDRESS = `0x55d398326f99059fF775485246999027B3197955`; 


// Contract Address TEST
// const INVEST_ADDRESS = `0x58625C8F01e66445c23cB242EB343583Af7a447a`;
const INVEST_ADDRESS = `0xd2E35447E2Ed734D5D75e7f713Ce8851e5bE411D`;


export {
    GMC_ADDRESS,
    USDT_ADDRESS,
    BNB_ADDRESS,
    INVEST_ADDRESS
}